<!-- Save and Restore Tab State (Level 1–5) -->

document.addEventListener('DOMContentLoaded', function () {
  const currentPath = window.location.pathname;

  // Restore previously active tabs (only if saved for this page)
  for (let i = 1; i <= 5; i++) {
    const savedData = localStorage.getItem('activeTabLevel' + i);
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        if (parsed.path === currentPath) {
          const tabTriggerEl = document.querySelector('[data-bs-target="' + parsed.target + '"]');
          if (tabTriggerEl) {
            const tab = new bootstrap.Tab(tabTriggerEl);
            tab.show();
          }
        }
      } catch (e) {
        // Ignore bad JSON
      }
    }
  }

  // Save tab state when clicked
  const tabTriggers = document.querySelectorAll('[data-bs-toggle="tab"]');
  tabTriggers.forEach(tabEl => {
    tabEl.addEventListener('shown.bs.tab', function (e) {
      const target = e.target.getAttribute('data-bs-target');
      const level = e.target.getAttribute('data-tab-level');
      if (target && level) {
        const saveObj = {
          path: currentPath,
          target: target
        };
        localStorage.setItem('activeTabLevel' + level, JSON.stringify(saveObj));
      }
    });
  });
});